import React from 'react'
import { AuthLayout } from '@/components/auth/AuthLayout'
import { ForgotPasswordForm } from '@/components/auth/ForgotPasswordForm'

export const ForgotPassword: React.FC = () => {
  return (
    <AuthLayout
      title="Forgot Password"
      description="Reset your account password"
    >
      <ForgotPasswordForm />
    </AuthLayout>
  )
}